import * as cx from 'classnames';
import { FULL_ANNOUNCEMENT, SHRINK_ANNOUNCEMENT } from 'mk/autogenerated/translations/AnnouncementBox.15e1a4d58eb5a71d3913a22f5393e985'
import { urlize } from 'mk/bazaar/common/filters';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import Emojify from 'mk2/components/Emojify';

class AnnouncementBox extends React.Component {
    constructor() {
        super();

        this.state = {
            shrinked: true,
            openAction: false,
            shrinkAction: false,
        };
    }

    render() {
        const {announcement} = this.props;
        const {shrinked, openAction, shrinkAction} = this.state;

        if (!announcement) return null;

        return (
            <div className="announcement-box g-bz-white-panel">
                <div className={cx('announcement-box__wrapper', {'announcement-box__wrapper--shrinked': shrinked})} ref="wrapper">
                    <div className="announcement-box__text" ref="text">
                        <Emojify>
                            {urlize(announcement)}
                        </Emojify>
                    </div>
                    <div className={cx('announcement-box__open-action', {'announcement-box__open-action--hidden': !openAction})}>
                        <div className="announcement-box__open-action-gradient" />
                        <button className="announcement-box__open-action-link g-link" onClick={() => this.onOpen()}>
                            {FULL_ANNOUNCEMENT}
                        </button>
                    </div>
                </div>
                <div className={cx('announcement-box__shrink-action', {'announcement-box__shrink-action--hidden': !shrinkAction})}>
                    <button className="announcement-box__shrink-action-link g-link" onClick={() => this.onShrink()}>
                        {SHRINK_ANNOUNCEMENT}
                    </button>
                </div>
            </div>
        );
    }

    componentDidMount() {
        if (this.props.announcement) {
            setTimeout(() => {
                if (this.refs.text.clientHeight > this.refs.wrapper.clientHeight) {
                    this.setState({openAction: true});
                }
            }, 0);
        }
    }

    onOpen() {
        this.setState({
            shrinked: false,
            openAction: false,
            shrinkAction: true,
        });
    }

    onShrink() {
        this.setState({
            shrinked: true,
            openAction: true,
            shrinkAction: false,
        });
    }
}

AnnouncementBox.propTypes = {
    announcement: PropTypes.string,
};

export default AnnouncementBox;
